import React from 'react';
import slugify from '@sindresorhus/slugify';
import { Link } from 'react-router-dom';

import PLACE_NAMES from '../../../constants/places';
import { WhitePanel } from '../../../components';

export default function UpsellLodge() {
  return (
    <React.Fragment>
      <WhitePanel className="cart-upsell">
        <h2>Other lodges you may want</h2>
        <div className="block-grid block-extra">
          {PLACE_NAMES.map(place => (
            <LodgeBox {...place} key={place.id} />
            ))}
        </div>
      </WhitePanel>
    </React.Fragment>
  );
}

function LodgeBox(props) {
  const { name, region, id, image } = props;

  const url = `/lodges?placeId=${id}&placeName=${slugify(name)}&region=${region}`;

  return (
    <Link to={url} className="block">
      <div className="block-background" style={{ backgroundImage: `url(${image})` }}>
        <img src={image} alt={name} />
      </div>
      <div className="block-content">
        <div style={{ fontSize: '19px' }}>
          <strong>LODGES IN {name.toUpperCase()}</strong>
        </div>
      </div>
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Cart/Listings/UpsellLodge.js